import clsx from "clsx";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Image from "next/image";
import bgOutline from "/public/onstep/bg-outline.png";
import bgOutlineSp from "/public/onstep/bg-outlineSp.png";
import outline from "/public/onstep/outline.png";
import outlineSP from "/public/onstep/outlineSp.png";

export const OnstepOutline = ({ id, className }) => {
  return (
    <Container
      id={id}
      className={clsx(
        className,
        "relative mx-auto flex",
        "items-start justify-start overflow-hidden",
        "md:min-h-auto p-6 sm:p-10 md:p-16 xl:px-24 xl:py-20"
      )}
    >
      <div className="z-10 mx-auto hidden aspect-[1216/738] w-full max-w-7xl md:block">
        <Image src={outline} alt="ONSTEPの概要図" className="h-auto w-full" />
      </div>
      <div className="z-10 mx-auto block aspect-[690/1223] w-full  md:hidden">
        <Image
          src={outlineSP}
          alt="ONSTEPの概要図（モバイル）"
          className="h-auto w-full"
        />
      </div>
      <div className="absolute inset-0 z-0 h-full w-full">
        <Image
          src={bgOutline}
          alt="ONSTEPの背景画像"
          quality={80}
          fill
          sizes="100vw"
          className="hidden object-cover md:block"
          priority={false}
        />
        <Image
          src={bgOutlineSp}
          alt="ONSTEPの背景画像"
          quality={80}
          fill
          sizes="100vw"
          className="block object-cover md:hidden"
          priority={false}
        />
      </div>
    </Container>
  );
};

export default OnstepOutline;
